module.exports = __webpack_public_path__ + "img/23_18.82d91bd6.png";